import { render } from "./longhorn.vue?vue&type=template&id=a8578116"
import script from "./longhorn.vue?vue&type=script&lang=js"
export * from "./longhorn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__